import { SampleTable } from "@/shared/components/ui";
import { useFetchPreagendamientos } from "@/shared/actions/erp";
import { useCheckPermissions, useTableColumnsPreagendamientoVentas } from "@/shared/hooks";
import { Button, Grid } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { useState } from "react";
import {  IPreagendamiento } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosPreagendamientoEnumChoice } from "@/shared/constants";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";

type InfoPreagendamientoProps = {
  codigo: string
}
export default function InfoPreagendamiento({ codigo }: InfoPreagendamientoProps) {
  useCheckPermissions(PermissionsEnum.api_view_preventa);

  const { columnaPreagendamiento } = useTableColumnsPreagendamientoVentas({ estado_preagendamiento: EstadosPreagendamientoEnumChoice.APROBADO });

  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const { isLoading, data: preventaResp,
  } = useFetchPreagendamientos({
    enabled: enabled,
    params: {
      page: 1,
      page_size: 1,
      codigo
    }
  });

  return (
    <>
      <Button
        color="primary"
        startIcon={<OpenInNew />}
        onClick={() => {
          setOpen(true)
          setEnabled(true)
        }}
      >
        VER
      </Button>

      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Preagendamiento"
            minWidth="75%"
            contentNode={
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SampleTable<IPreagendamiento>
                    isLoading={isLoading}
                    data={preventaResp?.data.data || []}
                    columns={columnaPreagendamiento}
                    enablePagination
                  />
                </Grid>
              </Grid>
            }
          />
        )
      }
    </>
  );



}